<script>

import {
  CdrBanner,
  CdrButton,
  IconErrorFill,
  IconInformationFill,
  IconWarningFill,
  IconCheckFill,
  IconXLg,
} from '@rei/cedar';

export default {
  name: 'AlertComponent',
  components: {
    CdrBanner,
    CdrButton,
    IconErrorFill,
    IconInformationFill,
    IconWarningFill,
    IconCheckFill,
    IconXLg,
  },
  props: {
    opened: {
      type: Boolean,
      required: true,
    },
    alertType: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  emits: ['onCloseAlert'],
  methods: {
    onCloseAlert() {
      this.$emit('onCloseAlert', false);
    },
  },
};
</script>

<template>
  <cdr-banner
    v-if="opened"
    :type="alertType"
  >
    <template #icon-left>
      <icon-error-fill
        v-if="alertType === 'error'"
        inherit-color
      />
      <icon-information-fill
        v-if="alertType === 'informational'"
        inherit-color
      />
      <icon-warning-fill
        v-if="alertType === 'warning'"
        inherit-color
      />
      <icon-check-fill
        v-if="alertType === 'success'"
        inherit-color
      />
    </template>
    <p
      class="alert-component__text"
      v-html="text"
    />
    <template #icon-right>
      <cdr-button
        :icon-only="true"
        aria-label="Close"
        @click="onCloseAlert"
      >
        <template #icon>
          <icon-x-lg inherit-color />
        </template>
      </cdr-button>
    </template>
  </cdr-banner>
</template>
